<div
    class="custom-toast toast-{{ toast.icon }} {{ toast.customClass }}"
    [ngClass]="getPositionClass()"
    [style.bottom.px]="toast.position?.startsWith('bottom') ? i * 100 + 10 : null"
    [style.top.px]="toast.position?.startsWith('top') ? i * 100 + 10 : null"
>
    <span class="toast-icon">
        <ng-container [ngSwitch]="toast.icon">
            <span *ngSwitchCase="'success'">✅</span>
            <span *ngSwitchCase="'error'"><i class="fa-solid fa-xmark"></i></span>
            <span *ngSwitchCase="'warning'">⚠️</span>
            <span *ngSwitchCase="'info'">ℹ️</span>
            <span *ngSwitchCase="'question'">❓</span>
        </ng-container>
    </span>

    <div class="toast-content">
        <h5 *ngIf="toast.title" class="toast-title">{{ toast.title }}</h5>
        <p *ngIf="toast.text" class="toast-text">{{ toast.text }}</p>
    </div>

    <button class="toast-close" *ngIf="toast.showCloseButton !== false" (click)="remove.emit(i)">
        &times;
    </button>

    <div
        class="toast-progress"
        *ngIf="toast.timer"
        [style.animation-duration.ms]="toast.timer"
    ></div>
</div>
